import { Card as MuiCard, CardProps as MuiCardProps, styled } from "@mui/material";

const StyledCard = styled(MuiCard)(({ theme }) => {
  return {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "0.5rem",
  };
});

interface CardProps extends MuiCardProps {
  children: React.ReactNode;
}

export const MutinexCard: React.FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

export default MutinexCard;
